import useTranslation from 'next-translate/useTranslation'
import { FC, MouseEvent, ReactNode } from 'react'
import { Button, FlexboxGrid, Panel } from 'rsuite'
import { Crisp } from 'crisp-sdk-web'

import ChatIcon from './Icons/ChatIcon'
import NextArrowIcon from './Icons/NextArrowIcon'

import styles from '../styles/ChatPanel.module.less'

interface ChatPanelProps {
  title?: string
  customTextContent?: ReactNode
  chatPanelCtaText?: string
  className?: string
  onClick?: (e: MouseEvent<HTMLElement>) => void
  hideBorder?: boolean
  hideArrow?: boolean
}

const ChatPanel: FC<ChatPanelProps> = ({
  title,
  customTextContent,
  chatPanelCtaText,
  className = '',
  onClick,
  hideBorder = false,
  hideArrow = false,
}) => {
  const { t } = useTranslation('modals')

  const handleChatClick = (e: MouseEvent<HTMLElement>) => {
    if (onClick) {
      onClick(e)
    } else {
      e.preventDefault()
    }

    Crisp.chat.show()
    Crisp.chat.open()
  }

  return (
    <div
      data-testid="chat-panel"
      className={`${styles['chat-panel']} ${className}`}
    >
      <Panel
        id="contact-modal-chat-button"
        onClick={handleChatClick}
        className={`padding-spacer ${styles['modal-panel-link']} ${hideBorder ? styles['hide-border'] : ''}`}
        bordered
      >
        <FlexboxGrid
          align="middle"
          justify="space-between"
          className="flex-flow-row"
        >
          <FlexboxGrid
            align="middle"
            className="flex-flow-row"
          >
            <ChatIcon className="flex-shrink-col-static" />
            <div className={`${styles['modal-panel-content']} margin-left-spacer-double flex-shrink-col-dynamic`}>
              {title && <p className="h4">{title}</p>}
              {customTextContent && <p className={`margin-bottom-spacer margin-right-spacer ${styles.subtitle}`}>{customTextContent}</p>}
              <Button
                appearance="link"
                onClick={handleChatClick}
                className={styles['modal-panel-link-style']}
              >
                {chatPanelCtaText || t('Chat with us')}
              </Button>
            </div>
          </FlexboxGrid>
          <NextArrowIcon className={`${styles['next-arrow-icon']} ${hideArrow ? styles.hide : ''}`} />
        </FlexboxGrid>
      </Panel>
    </div>
  )
}

export default ChatPanel
